export default[
  {
    path: '/api/system/assy/standard',
    name: 'AssemblyStandardInfo',
    meta: {
      pageTitle: '시스템 관리',
      title: '조립 기준정보',
      authRequired: true,
    },
    component: () => import('@/views/system/assyStdInfo')
  },
  {
    path: '/api/system/assy/teaching',
    name: 'AssemblyTeachingInfo',
    meta: {
      pageTitle: '시스템 관리',
      title: '조립로봇 티칭정보',
      authRequired: true,
    },
    component: () => import('@/views/system/assyTchInfo')
  },
  {
    path: '/api/system/insp/standard',
    name: 'InspectionStandardInfo',
    meta: {
      pageTitle: '시스템 관리',
      title: '검사 기준정보',
      authRequired: true,
    },
    component: () => import('@/views/system/inspStdInfo')
  },
  {
    path: '/api/system/insp/teaching',
    name: 'InspectionTeachingInfo',
    meta: {
      pageTitle: '시스템 관리',
      title: '검사로봇 티칭정보',
      authRequired: true,
    },
    component: () => import('@/views/system/inspTchInfo')
  },
  {
    path: '/api/system/prodeng',
    name: 'ProductEngine',
    meta: {
      pageTitle: '시스템 관리',
      title: '제품별 엔진정보',
      authRequired: true,
    },
    component: () => import('@/views/system/productEngine')
  },
  {
    path: '/api/system/product',
    name: 'ProductMaster',
    meta: {
      pageTitle: '시스템 관리',
      title: '제품 기준정보',
      authRequired: true,
    },
    component: () => import('@/views/system/productMaster')
  },
  {
    path: '/api/system/engine',
    name: 'EngineMaster',
    meta: {
      pageTitle: '시스템 관리',
      title: '엔진 기준정보',
      authRequired: true,
    },
    component: () => import('@/views/system/engineMaster')
  },

]